import { object } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { topic } from './shared/topic'
import { count } from './shared/count'
import { language } from './shared/language'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { Brainstorm } from 'blaze-ui/icons/24/Brainstorm'
import { contentType } from './shared/contentType'
import { TextChannels } from '../../../constants'

const meta = {
  type: GenerationType.Brainstorm,
  steps: ['Set Topic', 'Generate Ideas'],
  title: TextChannels[GenerationType.Brainstorm].name,
  submitLabel: 'Generate Ideas',
  icon: Brainstorm,
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183780/Home%20Card%20Previews/g2fmsqafmcc6vmfmmf2r.png',
}

const fields = {
  topic: topic.meta({ label: 'Give me ideas about...', generationType: meta.type }),
  ideas_count: count.min(5).max(20).default(10).meta({ label: 'How many ideas do you want?' }),
  content_type: contentType,
  language,
}

export const BrainstormSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>
